enum ArticleStatus {
    INACTIVE = "INACTIVE",
    INTERNAL = "INTERNAL",
    FOR_SALE = "FOR_SALE",
    REMOVED = "REMOVED"
}

export default ArticleStatus;
